import '@fancyapps/fancybox';

$(document).ready(() => {
  openEnterModal();
});

function openEnterModal() {
  $.ajax({
    url: ajaxurl,
    type: 'POST',
    data: {
      action: 'open_modal',
      lang: lang,
    },
  }).done(function(response) {
    $.fancybox.close();
    $.fancybox.open(response, {
      modal: true,
      protect: true,
      touch: {
        vertical: false,
      },
      clickSlide: false,
    });
    $('#enter_modal').on('submit', function(e) {
      e.preventDefault();
      validEnterModal();
    });
  });
}

function validEnterModal() {
  $.ajax({
    url: ajaxurl,
    type: 'POST',
    data: {
      action: 'valid_modal',
    },
  }).done(function(response) {
    $.fancybox.close();
  });
}
